import * as React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import FullscreenDialog from '../../../FullscreenDialog/components/FullscreenDialog';
import { useTheme } from '../../../theme';
import { Money as MoneyType } from '../../../types';
import Modal from '../../../Modal';
import { default as Button } from '../../../Button';

interface Props {
	content: React.ReactNode;
	isOpen: boolean;
	onClose: () => void;
	dialogType?: 'popup' | 'fullscreen';
	dialogHeader?: string;
	dialogClassName?: string;
	dialogContentClassName?: string;
	dialogHeaderClassName?: string;
	dialogControlsClassName?: string;
	dialogCloseClassName?: string;
	withoutControls?: boolean;
	dialogPopupHeaderClassName?: string;
	rules?: string | React.ReactNode;
	totalPrice?: MoneyType;
	mountOnEnter?: boolean;
	onClear?: () => void;
	bodyScroll?: boolean;
	hideHeader?: boolean;
	backButtonRender?: (onClose: () => void) => React.ReactNode;
}

const Dialog = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
	const { DialogStyles: theme } = useTheme('Service');
	const { t } = useTranslation('Service');

	return props.dialogType === 'fullscreen' ? (
		<FullscreenDialog
			isOpen={props.isOpen}
			onClose={props.onClose}
			title={props.dialogHeader}
			contentClassName={cn(theme.dialog__content, props.dialogContentClassName)}
			headerClassName={props.dialogHeaderClassName}
			closeClassName={props.dialogCloseClassName}
			fadeTransition={true}
			keepMounted={true}
			rootDialogClassName={theme.dialog}
			mountOnEnter={props.mountOnEnter}
			hideHeader={props.hideHeader}
			backButtonRender={props.backButtonRender}
			ref={ref}
		>
			{props.content}
		</FullscreenDialog>
	) : (
		<Modal
			scroll={props.bodyScroll ? 'body' : 'paper'}
			open={props.isOpen}
			onClose={props.onClose}
			maxWidth={false}
			classes={{
				root: theme.dialog,
				paper: cn(theme.paper, props.dialogClassName)
			}}
			keepMounted={true}
			mountOnEnter={props.mountOnEnter}
		>
			{props.dialogHeader && <div className={theme.popupHeader}>{props.dialogHeader}</div>}
			{props.content}
			{!props.withoutControls && (
				<div className={props.dialogControlsClassName}>
					<Button onClick={props.onClear} className={theme.dialog__button_clear}>
						{t('Clear')}
					</Button>
					<Button onClick={props.onClose} className={theme.dialog__button_done}>
						{t('Done')}
					</Button>
				</div>
			)}
		</Modal>
	);
});

export default Dialog;
